module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "Reset-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Reset-content-tab"
  }, [_c('ul', {
    staticClass: "list clearfix"
  }, [_c('li', {
    staticClass: "item",
    class: {
      active: _vm.Toggle
    },
    on: {
      "click": function($event) {
        _vm.tabToggle(true)
      }
    }
  }, [_vm._v("\n          手机号找回\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "item",
    class: {
      active: _vm.Flog
    },
    on: {
      "click": function($event) {
        _vm.tabToggle(false)
      }
    }
  }, [_vm._v("\n          邮箱找回\n        ")])]), _vm._v(" "), (_vm.Toggle) ? _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-phone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phone",
    attrs: {
      "type": "text",
      "placeholder": "输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-code clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "code",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.submit(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "getCode",
    attrs: {
      "type": "button",
      "disabled": _vm.BtnDisabled,
      "value": _vm.BtnCode
    },
    on: {
      "click": _vm.getCode
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-btn"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": _vm.SubmitBtn
    },
    on: {
      "click": function($event) {
        _vm.submit(true)
      }
    }
  })])]) : _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email",
    attrs: {
      "type": "text",
      "placeholder": "注册邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.submit(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_submit"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "验证邮箱"
    },
    on: {
      "click": function($event) {
        _vm.submit(false)
      }
    }
  })])])])]), _vm._v(" "), _c('MsgModal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Reset-content-title"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("安全验证")]), _vm._v(" "), _c('li', [_vm._v("重置密码")]), _vm._v(" "), _c('li', [_vm._v("修改成功")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "One"
  }), _vm._v(" "), _c('span', {
    staticClass: "Two"
  }), _vm._v(" "), _c('span', {
    staticClass: "Three"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e1c5026"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Validate.vue
// module id = 769
// module chunks = 1